/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import { Flex, Heading } from "@theme-ui/components";
import { Tag } from '../atoms';
import { colors, typography } from '../../styles/theme';

const PageHeading = props => {
  const backgroundImage = props.image ? `url(${props.image}) no-repeat bottom center` : "primary";

  return (
    <Flex
      sx={{
        flexDirection: "column",
        justifyContent: "flex-end",
        alignContent: "center",
        alignItems: "center",
        backgroundColor: colors.secondaryGreenMain,
        background: backgroundImage,
        minHeight: "15.063rem",
        pt: "3rem",
        px: [3, 3, 4, "9rem"],
        pb: "2.875rem"
      }}
      as="div"
    >
      {props?.tag && <Tag label={props.tag} bgColor="green" customStyles={{ mb: 3 }} /> }
      <Heading as='h1' sx={{ ...typography.h1, textAlign: "center" }}>{props.children}</Heading>
    </Flex>
  );
};

export default PageHeading;
